const JBL_VARIANT_ID = 46960380739798;
const GIFT_VARIANT_ID = 48377760415958;

let syncingGift = false;

async function getCart() {
  return fetch('/cart.js').then(r => r.json());
}

async function updateCart(updates) {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  });
}

async function addGift() {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: GIFT_VARIANT_ID,
      quantity: 1,
      properties: {
        _free_gift: 'true'
      }
    })
  });
}

async function syncGift() {
  if (syncingGift) return;
  syncingGift = true;

  try {
    const cart = await getCart();

    const jblItem = cart.items.find(
      item => item.variant_id === JBL_VARIANT_ID
    );

    const giftItems = cart.items.filter(
      item => item.variant_id === GIFT_VARIANT_ID
    );

    const hasJBL = !!jblItem;
    const giftQty = giftItems.reduce((t, i) => t + i.quantity, 0);

    const updates = {};

    // 🔴 eliminar duplicados
    if (giftItems.length > 1) {
      giftItems.slice(1).forEach(item => {
        updates[item.key] = 0;
      });
    }

    // 🔴 quitar regalo si no hay JBL
    if (!hasJBL && giftItems.length) {
      giftItems.forEach(item => {
        updates[item.key] = 0;
      });
    }

    // 🟢 agregar regalo si hay JBL y no hay regalo
    if (hasJBL && giftQty === 0) {
      await addGift();
      return;
    }

    // 🟡 forzar cantidad = 1
    if (giftItems.length === 1 && giftItems[0].quantity > 1) {
      updates[giftItems[0].key] = 1;
    }

    // aplicar cambios si hay
    if (Object.keys(updates).length > 0) {
      await updateCart(updates);
    }

  } finally {
    syncingGift = false;
  }
}

/* =========================
   TRIGGERS LIMPIOS (VOGAL)
========================= */

// 1. carga inicial
document.addEventListener('DOMContentLoaded', () => {
  syncGift();
});

// 2. fallback por fetch (AJAX cart)
const originalFetch = window.fetch;

window.fetch = async (...args) => {
  const response = await originalFetch(...args);

  const url = args[0]?.toString() || '';

  if (
    url.includes('/cart/add') ||
    url.includes('/cart/change') ||
    url.includes('/cart/update')
  ) {
    setTimeout(syncGift, 250);
  }

  return response;
};